const rankingItems = [
  { rank: 1, title: '顶流明星恋情疑似曝光：深夜同框照片引发全网热议', heat: '980万', trend: 'up', tag: '娱乐' },
  { rank: 2, title: '热门综艺节目录制现场突发状况，导演组紧急调整方案', heat: '860万', trend: 'up', tag: '综艺' },
  { rank: 3, title: '知名网红直播间言论引争议，品牌方连夜发声明回应', heat: '750万', trend: 'up', tag: '网红' },
  { rank: 4, title: '年度爆款剧大结局收视率创新高，第二季官宣定档', heat: '690万', trend: 'down', tag: '影视' },
  { rank: 5, title: '音乐节阵容全公开，多位重量级歌手确认加盟演出', heat: '580万', trend: 'up', tag: '音乐' },
  { rank: 6, title: '社交平台热门话题：明星私下聚会照流出，友情引猜测', heat: '520万', trend: 'down', tag: '社交' },
  { rank: 7, title: '吃瓜群众最期待：下半年已定档综艺节目完整清单', heat: '460万', trend: 'new', tag: '盘点' },
];

export default function RankingSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">吃瓜热度榜</h2>
            <p className="text-sm md:text-base text-foreground-500">
              实时追踪全网吃瓜话题热度，看看大家都在关注什么
            </p>
          </div>

          <div className="space-y-3">
            {rankingItems.map((item) => (
              <a
                key={item.rank}
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-lg hover:bg-background-200/50 transition-colors cursor-pointer group"
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-heading text-lg flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-400 text-background-50'
                    : item.rank === 3
                    ? 'bg-primary-300 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                      {item.tag}
                    </span>
                    <span className={`text-xs font-medium ${
                      item.trend === 'up' ? 'text-primary-500' : item.trend === 'new' ? 'text-accent-600' : 'text-foreground-400'
                    }`}>
                      {item.trend === 'up' && <i className="ri-arrow-up-line mr-0.5"></i>}
                      {item.trend === 'down' && <i className="ri-arrow-down-line mr-0.5"></i>}
                      {item.trend === 'new' && <i className="ri-add-line mr-0.5"></i>}
                      {item.heat}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1 font-medium">
                    {item.title}
                  </h3>
                </div>

                <div className="flex-shrink-0 text-foreground-300 group-hover:text-primary-500 transition-colors">
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}